import React from 'react'
import LayoutContentRight from '../../core/components/LayoutContentRight'
import FooterContainer from '../../core/containers/FooterContainer'
import LayoutWithAdminDrawerContainer from '../../core/containers/LayoutWithAdminDrawerContainer'
import AdminHeaderContainer from '../containers/AdminHeaderContainer'
import OrganisationAdminContentContainer from '../containers/OrganisationAdminContentContainer'

const OrganisationAdmin = () => (
  <LayoutWithAdminDrawerContainer
    renderContentRight={() => (
      <LayoutContentRight
        renderFooter={() => <FooterContainer />}
        renderHeader={() => <AdminHeaderContainer />}
        renderMain={() => <OrganisationAdminContentContainer />}
      />
    )}
  />
)

export default OrganisationAdmin
